import { useIsMaster, useSessionPermission } from '@btime/react-session'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useIsPermalinkPage } from '../../../../utils/session/permalinkToken'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import GroupSelect from '../../../../containers/groups/select/GroupSelect'
import ProfileSelect from '../../../../containers/profiles/select/ProfileSelect'
import UserSelect from '../../../../containers/users/select/UserSelect'
import { useModalData } from '../../../../components/modals/ModalsContext'
import WorkShiftsInput from '../../../../components/form/workShifts/WorkShiftsInput'
import CheckboxInput from '../../../../components/form/CheckboxInput'
import { useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'

const GeneralSection = () => {
  const { t } = useTranslation('editUser')
  const isMaster = useIsMaster()
  const { form, handleChange } = useFormState()
  const { id } = useModalData() || {}
  const requireUserGroup = useSessionPermission('requireUserGroup')
  const canUseAutomaticDistribution = useSessionPermission('useAutomaticDistribution')
  const isPublic = useIsPermalinkPage()

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="50%" wrapOn="sm">
        <FormItem label={t('name') + '*'} field="name" />
      </Col>

      <Col width="50%" wrapOn="sm">
        <Grid paddingGutter={0.2} wrap>
          <Col width="100%">
            <FormItem label={t('email') + '*'} field="email" autocomplete="email" />
          </Col>
          <Col paddingBottom={0}>
            <CheckboxInput
              label={t('fakeEmailQuestion')}
              value={form.isFakeEmail}
              onChange={value => handleChange('isFakeEmail', value)}
            />
          </Col>
        </Grid>
      </Col>

      {!isPublic && (
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('profile') + '*'} path={['contract', 'profile']} Input={ProfileSelect} />
        </Col>
      )}

      <Col width="50%" wrapOn="sm">
        <FormItem
          label={t('groups') + (requireUserGroup ? '*' : '')}
          path={['contract', 'groups']}
          Input={GroupSelect}
          multiple
          canCreate
        />
      </Col>

      {!!canUseAutomaticDistribution && (
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('productiveCapacity')} path={['contract', 'workShifts']} Input={WorkShiftsInput} />
        </Col>
      )}

      <Col width="50%" wrapOn="sm">
        <FormItem
          label={t('relatedUsers')}
          path={['contract', 'relatedUsers']}
          multiple
          Input={UserSelect}
          userIdToRemoveFromList={id}
        />
      </Col>

      {isMaster && (
        <Col width="50%" wrapOn="sm">
          <CheckboxInput
            label={t('canAccessPaymentModule')}
            value={form.canAccessPaymentModule}
            onChange={value => handleChange('canAccessPaymentModule', value)}
          />
        </Col>
      )}
    </Grid>
  )
}

export default GeneralSection
